<template>
  <div class="main-content jadwaldokter">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Detail Dokter</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="data != undefined" class="fasilitas-containter detail-doctor">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <div class="thumb">
              <i v-if="show_loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
              <img
                v-bind:src="(data == undefined) ? 'http://www.sttibontang.ac.id/asset/img_playlist/no-image.jpg' : data.picture"
                alt
                width="320"
              />
            </div>
          </div>
          <div class="col-md-8">
            <h3 class="name font-24 mt-0 mb-0">{{ data.name }}</h3>
            <h4 v-if="data.poli != ''" class="mt-5 text-theme-colored">{{ data.poli }}</h4>
            <i v-if="show_loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
            <p v-html="data.description"></p>
            <div class="col-md-12">
              <div class="row">
                <a
                  v-if="user_data != undefined && user_data.rm != '' && user_data.rm != null"
                  :href="appointment_url"
                  class="mt-5 color-white btn btn-dark btn-circled btn-default btn-sm btn-theme-colored"
                >Buat Janji</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import api from "../services/api";
import { TERRA_APPOINTMENT } from "../config/VariableComponents";

export default {
  data() {
    return {
      show_loading: false,
      data: {},
      user_data: {},
      appointment_url: "#",
    };
  },
  methods: {
    checkUser() {
      let getUserData = localStorage.getItem("user_data");
      if (getUserData != undefined) {
        this.logged = true;
        this.user_data = JSON.parse(getUserData);

        this.appointment_url = TERRA_APPOINTMENT + "?norm=" + this.user_data.rm;
      }
    },
    getDoctor(id) {
      this.show_loading = true;
      api
        .post(api.route.get.doctor, { id })
        .then((res) => {
          let status = res.status;
          if (status) {
            let data = res.data[0];
            this.data = data;
          }
          this.show_loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.show_loading = false;
        });
    },
  },
  watch: {
    "$route.params.id": {
      handler: function (value) {
        this.getDoctor(value);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.checkUser();
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/DetailDokter.vue